<template>
  <div>
    <h5 class="info-text">官方帳號設定</h5>
    <el-button type="primary" @click="noNeedMessagingApi()">不使用機器人</el-button>
    <div class="row justify-content-center">
      <div class="col-sm-3">
        <!-- <div class="picture-container">
          <el-upload
            class="picture"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="handlePreview"
            :auto-upload="false"
            :show-file-list="false"
          >
            <img v-if="model.imageUrl" :src="model.imageUrl" class="picture-src">
          </el-upload>
          <h6 class="description">Choose Picture</h6>
        </div> -->
      </div>
      <div class="col-sm-7">
        <div class="row">
          <label class="col-sm-3 col-form-label">Name*</label>
          <div class="col-sm-8">
            <fg-input name="accountName" placeholder="Name(required)" v-model="model.accountName" v-validate="modelValidations.accountName" :error="getError('accountName')"></fg-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">Channel ID*</label>
          <div class="col-sm-8">
            <fg-input name="channelId" placeholder="Channel ID(required)" v-model="model.channelId" v-validate="modelValidations.channelId" :error="getError('channelId')" :disabled="model.isChatbotDisabled"></fg-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">Channel Secret*</label>
          <div class="col-sm-8">
            <fg-input name="channelSecret" placeholder="Channel Secret(required)" v-model="model.channelSecret" v-validate="modelValidations.channelSecret" :error="getError('channelSecret')" :disabled="model.isChatbotDisabled"></fg-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">Channel Access Token*</label>
          <div class="col-sm-8">
            <fg-input name="channelAccessToken" placeholder="Channel Access Token(required)" v-model="model.channelAccessToken" v-validate="modelValidations.channelAccessToken" :error="getError('channelAccessToken')" :disabled="model.isChatbotDisabled"></fg-input>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <label class="col-sm-3 col-form-label">Channel Image Url*</label>
      <div class="col-sm-8">
        <fg-input name="channelImageUrl" placeholder="Channel Image Url(required)" v-model="model.channelImageUrl" v-validate="modelValidations.channelImageUrl" :error="getError('channelImageUrl')"></fg-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <label class="col-sm-3 col-form-label">Channel Add Friend Url*</label>
      <div class="col-sm-8">
        <fg-input name="channelAddFriendUrl" placeholder="Channel Add Friend Url(required)" v-model="model.channelAddFriendUrl" v-validate="modelValidations.channelAddFriendUrl" :error="getError('channelAddFriendUrl')"></fg-input>
      </div>
    </div>
      <div class="row justify-content-center">
      <label class="col-sm-3 col-form-label">Channel Basic ID*</label>
      <div class="col-sm-8">
        <fg-input name="channelBasicId" placeholder="Channel Basic ID e.g., @ABCDE" v-model="model.channelBasicId" v-validate="modelValidations.channelBasicId" :error="getError('channelBasicId')"></fg-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <label class="col-sm-3 col-form-label">Menu LIFF ID*</label>
      <div class="col-sm-8">
        <fg-input name="menuLiffId" placeholder="Menu LIFF ID(required)" v-model="model.menuLiffId" v-validate="modelValidations.menuLiffId" :error="getError('menuLiffId')"></fg-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <label class="col-sm-3 col-form-label">Eat-In LIFF ID*</label>
      <div class="col-sm-8">
        <fg-input name="eatInLiffId" placeholder="Eat-In LIFF ID(required)" v-model="model.eatInLiffId" v-validate="modelValidations.eatInLiffId" :error="getError('eatInLiffId')"></fg-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <label class="col-sm-3 col-form-label">Order LIFF ID*</label>
      <div class="col-sm-8">
        <fg-input name="orderLiffId" placeholder="Menu LIFF ID(required)" v-model="model.orderLiffId" v-validate="modelValidations.orderLiffId" :error="getError('orderLiffId')"></fg-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <label class="col-sm-3 col-form-label">Pick-up LIFF ID</label>
      <div class="col-sm-8">
        <fg-input name="pickUpLiffId" placeholder="Pick-up LIFF ID" v-model="model.pickUpLiffId" v-validate="modelValidations.pickUpLiffId" :error="getError('pickUpLiffId')"></fg-input>
      </div>
    </div>
  </div>
</template>
<script>
import { Upload } from "element-ui";
import axios from "axios";

import swal from "sweetalert2";
export default {
  components: {
    [Upload.name]: Upload
  },
  data() {
    return {
      publicPath: `${process.env.BASE_URL}`,
      model: {
        imageUrl: `${process.env.BASE_URL}img/jessica-alba-blue-skirt.jpg`,
        accountName: "",
        channelId: "",
        channelSecret: "",
        channelAccessToken: "",
        channelImageUrl: "",
        isChatbotDisabled: false,

      },
      modelValidations: {
        accountName: {
          required: true,
          max: 20
        },
        channelId: {
          required: true
        },
        channelSecret: {
          required: true
        },
        channelAccessToken: {
          required: true
        },
        channelImageUrl: {
          required: true
        },
        channelAddFriendUrl: {
          required: true
        },
        channelBasicId: {
          required: true
        },
        eatInLiffId: {
          required: true
        },
        menuLiffId: {
          required: true
        },
        orderLiffId: {
          required: true
        },
        pickUpLiffId: {
          required: false
        }
      }
      
    };
  },
  methods: {
    handlePreview(file) {
      this.model.imageUrl = URL.createObjectURL(file.raw);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },
    noNeedMessagingApi() {
      let config = {
        method: "get",
        url: `${process.env.VUE_APP_APIHOST}/gaa/generator/account-key`
      };

      axios(config)
      .then(res => {
        this.model.channelId = res.data.channelId;
        this.model.channelSecret = res.data.channelSecret;
        this.model.channelAccessToken = res.data.channelAccessToken;
        this.model.isChatbotDisabled = true;
      })
      .catch(err => {
        console.log(err);
        this.$message({
          type: 'error', message: err.message
        });
      })
      
    }
  }
};
</script>
<style>
</style>
